import { render, staticRenderFns } from "./DiagnosisAnalyze.vue?vue&type=template&id=28fb4b19&scoped=true&"
import script from "./DiagnosisAnalyze.vue?vue&type=script&lang=js&"
export * from "./DiagnosisAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisAnalyze.vue?vue&type=style&index=0&id=28fb4b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb4b19",
  null
  
)

export default component.exports